/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETINTERNSHIPSBYUSERID= createAsyncThunk(
  "getInternshipsByUserId/getInternshipsByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getInternshipsByUserIdSlice = createSlice({
  name: "getInternshipsByUserIdSlice",
  initialState: {
    getInternshipsByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetInternshipsByUserId: (state) => {
        state.getInternshipsByUserId.loading = false
        state.getInternshipsByUserId.error = false
        state.getInternshipsByUserId.data = []
        state.getInternshipsByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETINTERNSHIPSBYUSERID.fulfilled, (state, action) => {
      state.getInternshipsByUserId = {
        ...state.getInternshipsByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETINTERNSHIPSBYUSERID.pending, (state, action) => {
      state.getInternshipsByUserId = {
        ...state.getInternshipsByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETINTERNSHIPSBYUSERID.rejected, (state, action) => {
      state.getInternshipsByUserId = {
        ...state.getInternshipsByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getInternshipsByUserIdAction = {
    GETINTERNSHIPSBYUSERID,
};

export { getInternshipsByUserIdAction };
export default getInternshipsByUserIdSlice.reducer;
export const {setInitialStateOfgetInternshipsByUserId} = getInternshipsByUserIdSlice.actions